import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Route, Redirect } from "react-router-dom";

class AuthRoute extends React.PureComponent {

  render() {
    const { component: Component, ...rest} = this.props
    return (<Route
    {...rest}
    render={props =>
      this.props.isAuthenticated ? <Component {...props} /> : <Redirect to="/login" />}
  />)
  }
}

AuthRoute.propTypes = {
  component: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool.isRequired
};
function mapStateToProps(state) {
  return {
    isAuthenticated: !!state.auth.token
  };
}

export default connect(mapStateToProps)(AuthRoute);


// WEBPACK FOOTER //
// ./src/components/Router/AuthRouter.jsx